import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { t } from 'state/intl/translations';

import { useRemoveReward } from './use-remove-reward';

export type RemoveRewardButtonProps = {
  /** Sanity reward document id — removes only the applied line matching this reward. */
  rewardId: string;
};

/**
 * Removes one applied reward (mobile cart + Redux, or in-restaurant line) matching `rewardId`.
 */
export const RemoveRewardButton = ({ rewardId }: RemoveRewardButtonProps) => {
  const { handleRemove } = useRemoveReward(rewardId);

  return (
    <ActionButton
      variant={ActionButtonVariants.OUTLINE}
      size={ActionButtonSizes.SMALL}
      onPress={handleRemove}
      testID={`remove-reward-${rewardId}`}
    >
      {t('remove')}
    </ActionButton>
  );
};
